// Animated "thinking" placeholder shown while the agent is waiting on the
// LLM for the next turn. Without this, the thread sits silent during the
// /turn round-trip — the only feedback is the top-edge scan-line on the
// panel chrome, which is easy to miss when the user is reading their own
// message.
//
// Visible conditions: controller.busy AND the trailing message is either
// the user's prompt OR an assistant placeholder (the screenshot was pushed
// before /turn fires but the text + actions haven't arrived yet). Once a
// real response lands, the bubble retires and the action cards / prose
// take over. Tool-call execution phases don't re-trigger the bubble — the
// top scan-line is enough signal once a response has begun.

import React from "react";
import { observer } from "mobx-react";
import { Sparkles } from "lucide-react";
import { useCopilotController } from "../CopilotRuntimeProvider";

function isPlaceholder(msg) {
  return (
    msg.role === "assistant" &&
    !msg.text &&
    (!msg.actions || msg.actions.length === 0)
  );
}

export const ThinkingBubble = observer(function ThinkingBubble() {
  const controller = useCopilotController();
  if (!controller.busy) return null;
  const last = controller.messages[controller.messages.length - 1];
  if (last && last.role !== "user" && !isPlaceholder(last)) return null;

  return (
    <div className="copilot-thinking tw-flex tw-w-full tw-gap-2 tw-py-1" role="status" aria-live="polite">
      <div className="tw-mt-0.5 tw-flex tw-h-7 tw-w-7 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-accent tw-text-accent-foreground tw-shadow-sm">
        <Sparkles className="tw-h-3.5 tw-w-3.5" />
      </div>
      <div className="tw-min-w-0 tw-rounded-2xl tw-rounded-bl-md tw-bg-card tw-px-3.5 tw-py-2.5 tw-shadow-sm">
        <div className="copilot-thinking-row">
          <div className="copilot-thinking-bars" aria-hidden="true">
            <span /><span /><span /><span /><span />
          </div>
          <span className="copilot-thinking-label">thinking</span>
        </div>
      </div>
    </div>
  );
});
